export default {
  cleanExample: ({ commit }) => commit("updateExample", {})		
}